import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrgStructureCustomerComponent } from './org-structure-customer.component';

const routes: Routes = [
  {
    path: '',
    component: OrgStructureCustomerComponent,
    data: { title: 'Manage Organisation Structure' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrgStructureCustomerRoutingModule {}

@NgModule({
  imports: [
    OrgStructureCustomerRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [OrgStructureCustomerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrgStructureCustomerModule {}
